import { statusColors } from '../theme';
import styles from './StatusBadge.module.css';

export default function StatusBadge({ status, size = 'md' }) {
  const meta = statusColors[status] || { fg: '#6E6E6E', bg: '#F0F0F0', label: status };
  return (
    <span
      className={`${styles.badge} ${size === 'sm' ? styles.sm : ''}`}
      style={{ color: meta.fg, background: meta.bg }}
    >
      <span className={styles.dot} style={{ background: meta.fg }} />
      {meta.label}
    </span>
  );
}
